import { useCallback, useState } from "react";

/**
 * Набранное и не отправленное, по адресу чата.
 *
 * ⚠️ **Черновик живёт ВЫШЕ места показа намеренно, и мест, где это спасает,
 * два** (раздел 12 `docs/room-chat-design.md`). В комнате панель гаснет от
 * нажатия на соседнюю кнопку дока (открываться одновременно им нельзя) и
 * размонтируется вместе со своим состоянием. В расписании всплывающая карточка
 * закрывается на ЛЮБОЕ нажатие мимо и на Escape, то есть фразу уносило бы
 * движением мыши по соседней клетке. В строке списка уроков то же самое делает
 * сворачивание строки.
 *
 * ⚠️ **Хранится ПО АДРЕСУ, а не одной строкой.** Одна строка означала бы, что
 * набранное занятию во вторник всплывает в карточке занятия в среду: карточки
 * переключаются нажатием по сетке, и общий черновик уехал бы в чужой чат вместе
 * с нажатием «Отправить».
 *
 * ⚠️ **Ничего не чистится и никуда не сохраняется, и это осознанно.** Записи
 * весят по строке и живут ровно до перезагрузки страницы: карточек за сессию
 * открывают десятки, а не тысячи. Уносить их в `localStorage` нельзя вовсе:
 * это чужой текст про детей, оставленный на устройстве, которое бывает общим.
 */
export interface ChatDrafts {
  draftOf: (address: string | null) => string;
  setDraft: (address: string | null, value: string) => void;
  clear: (address: string) => void;
}

export function useChatDrafts(): ChatDrafts {
  const [drafts, setDrafts] = useState<Readonly<Record<string, string>>>({});

  const draftOf = useCallback(
    (address: string | null) => (address === null ? "" : (drafts[address] ?? "")),
    [drafts],
  );
  const setDraft = useCallback((address: string | null, value: string) => {
    if (address === null) return;
    setDrafts((prev) => ({ ...prev, [address]: value }));
  }, []);
  const clear = useCallback((address: string) => {
    setDrafts((prev) => ({ ...prev, [address]: "" }));
  }, []);

  return { draftOf, setDraft, clear };
}
